export const decodeSeparator = (str: string): string => decodeURIComponent(str);
